// config.js
const config = {
  //apiUrl: 'http://127.0.0.1:8000/api',
  apiUrl: 'https://meragym.com/admins/public/api',
};
export default config;